import { render, staticRenderFns } from "./SideMenuShop.vue?vue&type=template&id=eda70abe&scoped=true&lang=pug&"
import script from "./SideMenuShop.vue?vue&type=script&lang=js&"
export * from "./SideMenuShop.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuShop.vue?vue&type=style&index=0&id=eda70abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda70abe",
  null
  
)

export default component.exports